import { render, staticRenderFns } from "./patriarchSwitch.vue?vue&type=template&id=7936464e&scoped=true"
import script from "./patriarchSwitch.vue?vue&type=script&lang=js"
export * from "./patriarchSwitch.vue?vue&type=script&lang=js"
import style0 from "./patriarchSwitch.vue?vue&type=style&index=0&id=7936464e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7936464e",
  null
  
)

export default component.exports